'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useIsClient } from 'usehooks-ts';
import SortByPopover from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/SortByPopover';
import SortBySheet from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/SortBySheet';
import { useUAContext } from '@/context/UAContext';
import { SortValue } from '@/types/search';
type SortOption = {
  value: SortValue;
  label: string;
};
type SortByMenuProps = {
  sortBy: string;
  onSortChange: (value: SortValue) => void;
  sortOptions?: SortOption[];
  defaultValue?: string;
};
const useDefaultSortOptions = () => {
  const $ = _c(16);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("worlds-landing.search.sort.recommended");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      value: "recommended",
      label: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("worlds-landing.search.sort.release-date");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      value: "release-date",
      label: t2
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("worlds-landing.search.sort.last-updated-at");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = {
      value: "last_updated_at",
      label: t4
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t5) {
    t6 = [t1, t3, t5];
    $[12] = t1;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default function SortByMenu(t0) {
  const $ = _c(17);
  const {
    sortBy,
    onSortChange,
    sortOptions,
    defaultValue
  } = t0;
  const defaultOptions = useDefaultSortOptions();
  const {
    isMobile
  } = useUAContext();
  const isClient = useIsClient();
  const options = sortOptions || defaultOptions;
  let t1;
  if ($[0] !== defaultValue || $[1] !== options) {
    t1 = defaultValue && options.find(option_0 => option_0.value === defaultValue) || options.find(_temp);
    $[0] = defaultValue;
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const defaultSortOption = t1;
  let t2;
  if ($[3] !== defaultSortOption || $[4] !== options || $[5] !== sortBy) {
    t2 = options.find(option_1 => option_1.value === sortBy) || defaultSortOption;
    $[3] = defaultSortOption;
    $[4] = options;
    $[5] = sortBy;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const sortOption = t2;
  if (isMobile && isClient) {
    let t3;
    if ($[7] !== onSortChange || $[8] !== options || $[9] !== sortBy || $[10] !== sortOption) {
      t3 = <SortBySheet sortBy={sortBy} onSortChange={onSortChange} sortOptions={options} sortOption={sortOption} />;
      $[7] = onSortChange;
      $[8] = options;
      $[9] = sortBy;
      $[10] = sortOption;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  }
  let t3;
  if ($[12] !== onSortChange || $[13] !== options || $[14] !== sortBy || $[15] !== sortOption) {
    t3 = <SortByPopover sortBy={sortBy} onSortChange={onSortChange} sortOptions={options} sortOption={sortOption} />;
    $[12] = onSortChange;
    $[13] = options;
    $[14] = sortBy;
    $[15] = sortOption;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
}
function _temp(option) {
  return option.value === "recommended";
}